import React, { useState } from "react";
import * as Progress from "react-native-progress";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";
import { MainText, Box, SteppedProgressBar } from "app/components/common";
import normalize from "app/utils/normalize";

const CategoryRowWithStep = ({
  categoryTitle = "",
  progress = 0,
  hasImprovement = false,
  level = 1,
}) => {
  const [width, setWidth] = useState(300);

  const findDimensions = ({ height, width }) => {
    setWidth(width);
  };

  const handleOnLayout = event => {
    findDimensions(event.nativeEvent.layout);
  };

  return (
    <Box
      width="100%"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      marginBottom="l"
    >
      <Box
        width="100%"
        marginBottom="xs"
        alignItems="flex-start"
        justifyContent="space-between"
        flexDirection="row"
      >
        <MainText marginRight="s" variant="l3-bold" color="neutral.900">
          {categoryTitle}
          {hasImprovement ? (
            <MainText color="brand.500" variant="l3-bold">
              {" "}
              +1
            </MainText>
          ) : (
            ""
          )}
        </MainText>
        {level > 0 && (
          <MainText variant="l3-medium" color="neutral.600">
            {i18n.t("level")}
            <MainText color="neutral.600" variant="l3-medium">
              {level}
            </MainText>
          </MainText>
        )}
      </Box>
      <Box flexDirection="row" width="100%" onLayout={handleOnLayout}>
        <Box width="100%">
          <SteppedProgressBar
            stepHeight={6}
            spaceBetweenSteps={8}
            numberOfSteps={5}
            totalDone={progress * 10}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CategoryRowWithStep;
